import { render } from "./D_memTypeLeftTab.vue?vue&type=template&id=3ae22a0d"
import script from "./D_memTypeLeftTab.vue?vue&type=script&lang=js"
export * from "./D_memTypeLeftTab.vue?vue&type=script&lang=js"

import "./D_memTypeLeftTab.vue?vue&type=style&index=0&id=3ae22a0d&lang=css"
/* custom blocks */
import block0 from "./D_memTypeLeftTab.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__